import api from 'api';

export const RECIPE_CATEGORIES_ASYNC_ACTION_START = 'RECIPE_CATEGORIES_ASYNC_ACTION_START';
export const RECIPE_CATEGORIES_ASYNC_ACTION_ERROR = 'RECIPE_CATEGORIES_ASYNC_ACTION_ERROR';
export const RECIPE_CATEGORIES_ASYNC_UPDATE_SUCCESS = 'RECIPE_CATEGORIES_ASYNC_UPDATE_SUCCESS';
export const RECIPE_CATEGORIES_RESET_STATE = 'RECIPE_CATEGORIES_RESET_STATE';

function recipeCategoriesAsyncActionStart() {
  return {
    type: RECIPE_CATEGORIES_ASYNC_ACTION_START,
  };
}

function recipeCategoriesAsyncActionError(error) {
  return {
    type: RECIPE_CATEGORIES_ASYNC_ACTION_ERROR,
    error,
  };
}

function recipeCategoriesAsyncUpdateSuccess(data) {
  return {
    type: RECIPE_CATEGORIES_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

export function resetRecipeCategoriesState() {
  return {
    type: RECIPE_CATEGORIES_RESET_STATE,
  };
}

export function recipeCategoriesAsync() {
  return (dispatch, getState) => {
    dispatch(recipeCategoriesAsyncActionStart());
    return api.request('recipeCategory/list', 'get')
    .then((data) => {
      dispatch(recipeCategoriesAsyncUpdateSuccess(data.subCategory));
      return data.subCategory;
    })
    .catch((err) => {
      dispatch(recipeCategoriesAsyncActionError('Unable to get Recipe Categories'));
      throw (err);
    });
  };
}
